/**
 * Package-based visual theming. Each student's package type drives the
 * colors used for progress bars, percentages and accent glows across the UI.
 *
 * Economy        -> Blue  (aura: soft blue glow)
 * Business       -> Gray  (aura: cool silver glow)
 * First Class    -> Purple (aura: violet glow)
 * Spoedopleiding -> Gold  (default brand, aura: gold glow)
 */
export const PACKAGE_THEMES = {
    economy: {
        primary: '#3B82F6',
        light: '#60A5FA',
        hex: '#3B82F6',
        barClass: 'bg-gradient-to-r from-[#3B82F6] via-[#60A5FA] to-[#3B82F6]',
        solidBarClass: 'bg-[#3B82F6]',
        textClass: 'text-[#60A5FA]',
        ringBg: 'bg-[#3B82F6]/10',
        ringBorder: 'border-[#3B82F6]/40',
        pillClass: 'bg-[#3B82F6]/15 text-[#60A5FA] border-[#3B82F6]/40',
        aura: 'rgba(59, 130, 246, 0.35)',
        auraSoft: 'rgba(59, 130, 246, 0.18)',
    },
    business: {
        primary: '#9CA3AF',
        light: '#D1D5DB',
        hex: '#9CA3AF',
        barClass: 'bg-gradient-to-r from-[#9CA3AF] via-[#D1D5DB] to-[#9CA3AF]',
        solidBarClass: 'bg-[#9CA3AF]',
        textClass: 'text-[#D1D5DB]',
        ringBg: 'bg-[#9CA3AF]/10',
        ringBorder: 'border-[#9CA3AF]/40',
        pillClass: 'bg-[#9CA3AF]/15 text-[#D1D5DB] border-[#9CA3AF]/40',
        aura: 'rgba(156, 163, 175, 0.35)',
        auraSoft: 'rgba(156, 163, 175, 0.18)',
    },
    first_class: {
        primary: '#A855F7',
        light: '#C084FC',
        hex: '#A855F7',
        barClass: 'bg-gradient-to-r from-[#A855F7] via-[#C084FC] to-[#A855F7]',
        solidBarClass: 'bg-[#A855F7]',
        textClass: 'text-[#C084FC]',
        ringBg: 'bg-[#A855F7]/10',
        ringBorder: 'border-[#A855F7]/40',
        pillClass: 'bg-[#A855F7]/15 text-[#C084FC] border-[#A855F7]/40',
        aura: 'rgba(168, 85, 247, 0.35)',
        auraSoft: 'rgba(168, 85, 247, 0.18)',
    },
    nationale_rijschool: {
        primary: '#F97316',
        light: '#FB923C',
        hex: '#F97316',
        barClass: 'bg-gradient-to-r from-[#F97316] via-[#FB923C] to-[#F97316]',
        solidBarClass: 'bg-[#F97316]',
        textClass: 'text-[#FB923C]',
        ringBg: 'bg-[#F97316]/10',
        ringBorder: 'border-[#F97316]/40',
        pillClass: 'bg-[#F97316]/15 text-[#FB923C] border-[#F97316]/40',
        aura: 'rgba(249, 115, 22, 0.35)',
        auraSoft: 'rgba(249, 115, 22, 0.18)',
    },
    // Fallback for spoedopleiding* and unknown packages: brand gold
    default: {
        primary: '#D4A537',
        light: '#FFD96A',
        hex: '#D4A537',
        barClass: 'bg-gradient-to-r from-[#D4A537] via-[#FFD96A] to-[#D4A537]',
        solidBarClass: 'bg-[#D4A537]',
        textClass: 'text-[#D4A537]',
        ringBg: 'bg-[#D4A537]/10',
        ringBorder: 'border-[#D4A537]/40',
        pillClass: 'bg-[#D4A537]/10 text-[#D4A537] border-[#D4A537]/40',
        aura: 'rgba(212, 165, 55, 0.35)',
        auraSoft: 'rgba(212, 165, 55, 0.18)',
    },
};

export function getPackageTheme(packageType) {
    if (!packageType) return PACKAGE_THEMES.default;
    if (PACKAGE_THEMES[packageType]) return PACKAGE_THEMES[packageType];
    // spoedopleiding variants fall through to default (gold)
    return PACKAGE_THEMES.default;
}
